/** @jsx jsx */
import { jsx } from '@emotion/core'
//import { Fragment } from 'react';
import env from 'env';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loading } from 'components';

export function MemberEdit(props){

    const id = useParams().id;
    const [result, setResult] = useState();
    const [pageLoading, setPageLoading] = useState(true);
    const [trigger, setTrigger] = useState(0);

    const onSubmit = ((e) => {
        e.preventDefault();
        e.stopPropagation();
        
        setPageLoading(true);
        setTrigger(1);
    });

    const handChange = (el => {
        const elName = el.target.name;
        const elValue =el.target.value;
        //setResult({...result.userInfo, [elName] : elValue});
        //setResult({...result.userInfo, [elName] : elValue});
        setResult(pre => {
            let _new = {...pre};
            _new.userInfo = {..._new.userInfo, [elName] : elValue}
            return _new;
        });
    });

    useEffect(() => {
        const fetchData = async () => {
            const res = await fetch(env.apiBase + "/api/profile/getuserprofileinadmin/" + id);
            const data = await res.json();
            console.log('data', data);
            setResult({
                errors : data.errors,
                userInfo : data.results.userInfo
            });
            setPageLoading(false);
        };
        fetchData();
    }, [id]);

    useEffect(() => {
        if(trigger === 0){
            return;
        }
        const fetchData = async () => {
            const res = await fetch(env.apiBase + '/api/profile/updateprofilestatus', {
                method : 'post',
                headers: { 
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(result.userInfo)
            });
            const data = await res.json();
            setResult({
                errors : data.errors,
                userInfo : data.results.userInfo
            });
            setTimeout(() => {
                setPageLoading(false);    
            }, 1000); 
        };
        fetchData();
        setTrigger(0);
    }, [trigger, result]);

    return(
        pageLoading ? <Loading></Loading> :
        (
            result.errors.length > 0 ?
            <div>
                {
                    result.errors.map((item, index) => <div key={index}> {item.errorMessage} </div>)
                }
            </div> :
            <form onSubmit = {onSubmit} autoComplete="off">
                <h2> { result.userInfo.name } </h2>
                <hr />
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label"> 
                        Member Status
                    </label>
                    <div className="col-sm-5">
                        <select className="form-control" value={result.userInfo.profileStatus} name="profileStatus" onChange={handChange}>
                            <option value='0'> Active </option>
                            <option value='99'> Inactive </option>
                        </select>
                    </div>
                    <div className="col-sm-3">
                        <button type="submit" className="btn btn-primary"> Change Member Status </button>
                    </div>
                </div>
                <hr />
                <h3 style={{marginBottom:'0.5rem'}}>User Information</h3>
                <div className="row">
                    <div className="col-2" style={{margin:'0.25rem 0px'}}>
                        Email :
                    </div>
                    <div className="col-10" style={{margin:'0.25rem 0px'}}>
                        { result.userInfo.email }
                    </div>
                    <div className="col-2" style={{margin:'0.25rem 0px'}}>
                        Organisation :
                    </div>
                    <div className="col-10" style={{margin:'0.25rem 0px'}}>
                        { result.userInfo.organisation }
                    </div>
                </div>
            </form>
        )
    )
}